<template>
  <div class="configurable-list">
    <div v-if="data" class="panel panel-default border-panel card-view">
      <div class="panel-heading">
        <div class="row">
          <div class="col-sm-12">
            <div class="pull-left">
              <h6 class="panel-title txt-dark">
                <i v-if="hasNavigation" class="ti-angle-left action-button" @click="navigateBack"></i>
                <span v-if="title">{{title}}</span>
              </h6>
            </div>
            <div v-if="subTitle" class="pull-right panel-title txt-dark sub-title" @click="sendSubTitleAction(subTitleAction)">
              <span >{{subTitle}}</span>
              <i class="ti-angle-right"></i>
            </div>
          </div>
          <div v-if="hasSearch" class="col-sm-6">
            <search-input :placeholder="searchLabel" @input="search"/>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="panel-wrapper collapse in">
        <div class="panel-body">
          <div class="table-wrap mt-10">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr style="width: 100%">
                    <th
                      v-for="(header, index) in fields"
                      :key="index"
                      :class="[fields[index].cellClass, fields[index].cellClass == 'specs-cell' ?  'no-border-bottom' : '']"
                    >
                      <span v-if="header['orderable'] && header['orderable'] === true" :class="`order-title ${fields[index].cellClass}-header`" @click="order(header['key'])">{{header['title']}}
                        <img src="static/arrow-down.png" class="order-arrow">
                        <img src="static/arrow-up.png" class="order-arrow">
                      </span>
                      <span v-else >{{header['title']}}</span>
                    </th>
                    <th v-if="hasCheckbox">
                      <base-checkbox
                        ref='checkAll'
                        :id="`check-all`"
                        @valueChanged="checkAll($event)"
                      />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style="width: 100%"
                    :class="row.for_modified_question && row.for_modified_question === true? 'table-row warning' : 'table-row'"
                    v-for="(row, index) in data"
                    :key="index"
                  >
                    <td
                      v-for="(field, keyIndex) in fields"
                      :key="keyIndex"
                      :class="fields[keyIndex].cellClass"
                      :style="{ display: (fields[keyIndex].isAction != undefined && fields[keyIndex].isAction != false && fields[keyIndex].checkForStatus !== undefined && fields[keyIndex].checkForStatus !== false) && row['status'] != fields[keyIndex].status ? 'none' : 'table-cell' }"
                    >
                      <span
                        v-if="(fields[keyIndex].isLink != undefined
                        && fields[keyIndex].isLink != false && fields[keyIndex].historyPath != false)"
                      >
                        <div
                          class="base-link"
                        >
                          <span :class="fields[keyIndex].class" @click="showHistoryModal(row.id)">{{row[field.key]}}</span>
                        </div>
                      </span>
                      <span
                        v-else-if="(fields[keyIndex].isLink != undefined && fields[keyIndex].isLink != false)"
                      >
                        <router-link
                          class="base-link"
                          :to="`/${fields[keyIndex].route_path}/${row.id}`"
                        >
                          <span :class="fields[keyIndex].class">{{row[field.key]}}</span>
                        </router-link>
                      </span>
                      <span v-else-if="(fields[keyIndex].subTitles != undefined)">
                        <span
                          v-for="(subtitle, index) in fields[keyIndex].subTitles"
                          :key="index"
                          :class="fields[keyIndex].class">
                            {{row[field.elements[index]] + " " + subtitle}}
                        </span>
                      </span>
                      <span
                        v-else-if="(fields[keyIndex].isAction != undefined && fields[keyIndex].isAction != false && fields[keyIndex].isNested != undefined && fields[keyIndex].isNested != false)"
                      >
                        <a class="pull-left inline-block action-button">
                          <i
                            @click="makeNestedAction(row,fields[keyIndex].key)"
                            :class="`${fields[keyIndex].class}`"
                          ></i>
                        </a>
                      </span>
                      <span
                        v-else-if="(fields[keyIndex].isAction != undefined && fields[keyIndex].isAction != false && fields[keyIndex].checkForStatus !== undefined && fields[keyIndex].checkForStatus !== false)"
                      >
                        <a class="pull-left inline-block action-button">
                          <i
                            @click="makeAction(row.id,fields[keyIndex].key)"
                            :class="row['status'] === fields[keyIndex].status || fields[keyIndex].disabled ? `${fields[keyIndex].class}`: 'hidden'"
                          ></i>
                        </a>
                      </span>
                      <span
                        v-else-if="(fields[keyIndex].isAction != undefined && fields[keyIndex].isAction != false && fields[keyIndex].checkForStatus !== undefined && fields[keyIndex].checkForStatus === false)"
                      >
                        <a class="pull-left inline-block action-button">
                          <i
                            @click="makeAction(row.id,fields[keyIndex].key)"
                            :class="row['status'] === fields[keyIndex].status || fields[keyIndex].disabled ? 'hidden' : `${fields[keyIndex].class}`"
                          ></i>
                        </a>
                      </span>
                      <span
                        v-else-if="(fields[keyIndex].isAction != undefined && fields[keyIndex].isDownload != false && fields[keyIndex].key === 'download')"
                      >
                        <a  v-if="row.asset" target="_blank" :href="row.asset.url" class="pull-left inline-block action-button">
                          <i
                            :class="`${fields[keyIndex].class}`"
                          ></i>
                        </a>
                      </span>
                      <span
                        v-else-if="(fields[keyIndex].isAction != undefined && fields[keyIndex].isAction != false) && fields[keyIndex].forStatement != undefined && fields[keyIndex].forStatement === true"
                      >
                        <a v-if="row['verification_question_name'] !== ''" class="pull-left inline-block action-button">
                          <i
                            @click="makeAction(row.id,fields[keyIndex].key)"
                            :class="`${fields[keyIndex].class}`"
                          ></i>
                        </a>
                      </span>
                      <span
                        v-else-if="(fields[keyIndex].isAction != undefined && fields[keyIndex].isAction != false) && fields[keyIndex].key === 'changeUser'"
                      >
                        <a v-if="row['has_token'] && row['has_token'] === true" class="pull-left inline-block action-button">
                          <i
                            @click="makeAction(row.id,fields[keyIndex].key)"
                            :class="`${fields[keyIndex].class}`"
                          ></i>
                        </a>
                      </span>
                      <span
                        v-else-if="(fields[keyIndex].isAction != undefined && fields[keyIndex].isAction != false) && isInspectionSreen && fields[keyIndex].key === 'delete'"
                      >
                        <a v-if="row['status'] !== 'completed'" class="pull-left inline-block action-button">
                          <i
                            @click="makeAction(row.id,fields[keyIndex].key)"
                            :class="fields[keyIndex].disabled ? 'hidden' : `${fields[keyIndex].class}`"
                          ></i>
                        </a>
                      </span>
                      <span
                        v-else-if="(fields[keyIndex].isAction != undefined && fields[keyIndex].isAction != false) && fields[keyIndex].key == 'lock'"
                      >
                        <a class="pull-left inline-block action-button">
                          <i
                            @click="makeAction(row.id,fields[keyIndex].key,row.partner_forbidden)"
                            :class="row.partner_forbidden ? 'zmdi zmdi-lock-open' : 'zmdi zmdi-lock-outline'"
                          ></i>
                        </a>
                      </span>
                      <span
                        v-else-if="(fields[keyIndex].isAction != undefined && fields[keyIndex].isAction != false)"
                      >
                        <a class="pull-left inline-block action-button">
                          <i
                            @click="makeAction(row.id,fields[keyIndex].key)"
                            :class="`${fields[keyIndex].class}`"
                          ></i>
                        </a>
                      </span>
                      <span v-else-if="(fields[keyIndex].icons != undefined)">
                        <a
                          v-for="(icon, iconIndex) in fields[keyIndex].icons"
                          :key="iconIndex"
                          class="pull-left inline-block"
                        >
                          <v-popover v-if="icon === 'ti-info'" :trigger="'hover'">
                              <i
                                :class="`${icon} active`"
                              ></i>
                              <template slot="popover">
                                <info-popup
                                  :data="row"/>
                              </template>
                            </v-popover>
                          <i
                            v-if="row[fields[keyIndex].keys[iconIndex]] === true && icon !== 'ti-info' && fields[keyIndex].action != undefined"
                            @click="sendIconAction(fields[keyIndex].action,row)"
                            style="cursor: pointer"
                            :class="`${icon} active`">
                          </i>
                          <i
                            v-else-if="row[fields[keyIndex].keys[iconIndex]] === true && icon !== 'ti-info'"
                            :class="`${icon} active`"
                          ></i>
                          <i
                            v-else-if="!row[fields[keyIndex].keys[iconIndex]] && icon === 'zmdi zmdi-check'"
                            :class="`${icon} active`"
                            @click="updateStatement($event, {selectedStatement: row,status: 'built_in'})"
                          ></i>
                          <i
                            v-else-if="!row[fields[keyIndex].keys[iconIndex]] && icon === 'zmdi zmdi-close'"
                            :class="`${icon} active`"
                            @click="updateStatement($event, {selectedStatement: row,status: 'not_built_in'})"
                          ></i>
                          <i v-else-if="icon !== 'ti-info'" :class="`${icon} inactive`"></i>
                        </a>
                      </span>
                      <span
                        v-else-if="(fields[keyIndex].isIcons != undefined && fields[keyIndex].isIcons != false)"
                      >
                        <a
                          v-for="(icon, iconIndex) in row[field.key]"
                          :key="iconIndex"
                          class="pull-left inline-block"
                        >
                          <i :class="`${icon}`"></i>
                        </a>
                      </span>
                      <span
                        v-else-if="(fields[keyIndex].secondAttribute != undefined && row[field.key] !== undefined && row[field.key] !== null)"
                        :class="fields[keyIndex].class"
                        :title="row[field.key][field.secondAttribute]"
                      >{{row[field.key][field.secondAttribute]}}</span>
                      <span
                        v-else-if="(fields[keyIndex].arrayAttribute != undefined)"
                        v-for="(rowField, rowIndex) in row[field.key]"
                        :key="rowIndex"
                        :title="rowField[fields[keyIndex].arrayAttribute]"
                        :class="arraySpanClass(field,row[field.key])"
                      >
                        <a v-if="field.list" target="_blank" :href="rowField['url']">
                          {{field.list.filter((x) => x.value === rowField.id).map((y) => y.text)[0]}}
                        </a>
                        <a v-else target="_blank" :href="rowField['url']">
                          {{rowField[fields[keyIndex].arrayAttribute]}}
                        </a>
                      </span>
                      <span
                        v-else-if="(fields[keyIndex].subClass != undefined && fields[keyIndex].withTranslation != undefined && fields[keyIndex].withTranslation === true)"
                        :class="fields[keyIndex].class + '-' + row[field.subClass]"
                        :title="row[field.key]"
                      >{{$t(`${fields[keyIndex].translation}.${row[field.key]}`)}}</span>
                      <span
                        v-else-if="(fields[keyIndex].subClass != undefined)"
                        :class="fields[keyIndex].class + '-' + row[field.subClass]"
                        :title="row[field.key]"
                      >{{row[field.key]}}</span>
                      <span
                        v-else-if="(fields[keyIndex].isDate != undefined && fields[keyIndex].isDate === true)"
                        :class="fields[keyIndex].class"
                        :title="row[field.key]"
                      >{{row[field.key] | moment("YYYY-MM-DD")}}</span>
                      <span
                        v-else-if="(fields[keyIndex].isLocation != undefined && fields[keyIndex].isLocation === true)"
                        :class="fields[keyIndex].class"
                        :title="row[field.key]"
                        style="cursor: pointer"
                        @click="openMap(row)"
                      >
                        {{row[field.key]}}
                      </span>
                      <span
                        v-else-if="(fields[keyIndex].withTranslation != undefined && fields[keyIndex].withTranslation === true)"
                        :class="fields[keyIndex].class"
                        :title="row[field.key]"
                      >{{$t(`${fields[keyIndex].translation}.${row[field.key]}`)}}</span>
                      <span
                        v-else
                        :class="fields[keyIndex].class"
                        :title="row[field.key]"
                      >{{row[field.key]}}</span>
                    </td>
                    <td v-if="hasCheckbox">
                      <base-checkbox
                        :id="`checkbox-${row.id}`"
                        :value="isSelected(row.id)"
                        @valueChanged="selectionChanged(row,$event)"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!data || data.length === 0" class="empty-section">{{loadingText}}</div>
  </div>
</template>

<script>
import BaseCheckbox from '../../shared/inputs/BaseCheckbox';
import SearchInput from '@/components/shared/inputs/SearchInput';
import InfoPopUp from '@/components/modules/base_states/InfoPopUp';
import LocationPopUp from '@/components/modules/partners/LocationPopUp';
import GenericForm from '@/components/shared/forms/GenericForm';
import StatementHistoryScreen from '@/components/modules/inspections/StatementHistoryScreen';

export default {
  name: 'ConfigurableList',
  components: {
    'base-checkbox': BaseCheckbox,
    'search-input': SearchInput,
    'info-popup': InfoPopUp,
    'location-popup': LocationPopUp,
    GenericForm,
    StatementHistoryScreen,
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    subTitle: {
      type: String,
      required: false,
    },
    subTitleAction: {
      type: String,
      required: false,
    },
    data: {
      type: Array,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    hasCheckbox: {
      type: Boolean,
      default: false,
    },
    hasSearch: {
      type: Boolean,
      default: false,
    },
    searchLabel: {
      type: String,
      default: '',
    },
    hasNavigation: {
      type: Boolean,
      default: false,
    },
    hasSubTable: {
      type: Boolean,
      default: false,
    },
    subData: {
      type: Array,
      required: false,
    },
    subFields: {
      type: Array,
      required: false,
    },
    selection: {
      type: Array,
      default: () => [],
    },
    loadingText: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      defaultOrder: 'DESC',
    };
  },
  computed: {
    isInspectionSreen() {
      return this.$route.name === 'InspectionsScreen';
    },
  },
  mounted() {
  },
  methods: {
    showHistoryModal(statementId) {
      this.$eventBus.showModal({
        bind: {
          is: StatementHistoryScreen,
          title: this.$t('app.statements.set_statement'),
          statementId,
        },
        on: {
        },
        width: '1000px',
      });
    },
    arraySpanClass(field, list) {
      if (list && list.length > 0) {
        if (field.forLocation && field.forLocation === true) {
          return 'location-array-span';
        }
        return 'array-span';
      }
      return '';
    },
    updateStatement(event, data) {
      this.$emit('updateStatement', { selectedStatement: data.selectedStatement, status: data.status });
    },
    makeAction(id, actionType, locked = false) {
      this.$emit('actionMade', { id, actionType, locked });
    },
    makeNestedAction(row, actionType) {
      this.$emit('nestedActionMade', { row, actionType });
    },
    makeSubAction(id, actionType) {
      this.$emit('subActionMade', { id, actionType });
    },
    search(keyword) {
      this.$emit('search', keyword);
    },
    navigateBack() {
      this.$emit('navigateBack');
    },
    selectionChanged(row, value) {
      this.$emit('selectionChanged', row, value);
    },
    checkAll(value) {
      this.$emit('checkAll', value);
    },
    openMap(id) {
      this.$emit('openMap', id);
    },
    isSelected(id) {
      return this.selection[id] === true;
    },
    sendIconAction(action, row) {
      this.$emit(action, row);
    },
    order(attribute) {
      this.$emit('orderTable', { order: attribute, direction: this.defaultOrder });
      if (this.defaultOrder === 'DESC') {
        this.defaultOrder = 'ASC';
      } else {
        this.defaultOrder = 'DESC';
      }
    },
    sendSubTitleAction(action) {
      this.$emit(action);
    },

  },
};
</script>

<style lang="scss">
.configurable-list {
  table {
    tbody {
      tr {
        border-top: 1px solid #eee;
      }
    }
  }
  .card-view {
    margin-left: 0;
    margin-right: 0;
  }
  .zmdi-check {
    color: var(--main-color);
    font-size: 22px;
    cursor: pointer;
  }

  .zmdi-close {
    padding-left: 7px;
    font-size: 22px;
    cursor: pointer;
  }

  .panel-heading {
    min-height: 55px;
  }
  td {
    white-space: normal !important;
    word-wrap: break-word;
  }
  .ti-angle-right {
    font-size: 13px !important;
  }
  .sub-title {
    cursor: pointer;
  }
  .warning {
    background: rgba(255, 0, 0, 0.199);
  }
  .order-title {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .order-arrow {
    height: 13px;
  }

  .action-button {
    cursor: pointer;
  }

  .base-link {
    cursor: pointer;
    font-weight: 500;
  }

  .table-row:hover {
    background-color: rgba(33, 33, 33, 0.05) !important;
  }

  table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;

    .no-border-bottom {
      border-bottom: 0px !important;
    }

    span {
      // white-space: nowrap;
      // overflow: hidden;
      display: block;
      text-overflow: ellipsis;
    }

    i.active {
      color: var(--main-color);
    }

    i.inactive {
      color: #bcbccb;
    }

    [class*="ti-"] {
      font-size: 20px !important;
    }
  }
  .array-span {
    background: var(--main-color);
    border-radius: 4px;
    color: #ffffff;
    font-size: 11px;
    padding: 3px 4px 3px 4px;
    margin-right: 10px;
    float: left;
    text-align: center;
    a {
      color: #ffffff;
    }
  }
  .location-array-span {
    max-width: 90px;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
    background: var(--main-color);
    border-radius: 4px;
    color: #ffffff;
    font-size: 11px;
    padding: 3px 4px 3px 4px;
    margin-right: 10px;
    float: left;
    text-align: center;
    a {
      color: #ffffff;
    }
  }

  .empty-section {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-top: 40px;
  }

  .hidden {
    display: none;
  }
  .identifier-cell,
  .id-cell {
    font-weight: bold;
  }
}

.location-tooltip-arrow {
  display: none;
}

.location-tooltip-wrapper {
  background: #f9f9f9;
  max-width: 600px;
  width: 600px;
}

.location-tooltip-base, .location-tooltip-inner {
  max-width: 600px;
  width: 600px;
}

</style>1



// WEBPACK FOOTER //
// src/components/shared/lists/ConfigurableList.vue